import type { BrandId } from '@dh-io-owpi/backend-api/src/data-contracts';

export function getSubBrandAssets(subBrand: BrandId = 'MERCEDES_BENZ') {
  let backplate: string;
  let pattern: string;

  switch (subBrand) {
    case 'MERCEDES_AMG':
      backplate = 'images/backgrounds/AMG/AMG_backplate.jpg';
      pattern = 'images/backgrounds/AMG/AMG_pattern.png';
      break;
    case 'MERCEDES_MAYBACH':
      backplate = 'images/backgrounds/MAYBACH/MAYBACH_backplate.jpg';
      pattern = 'images/backgrounds/MAYBACH/MAYBACH_pattern.png';
      break;
    default:
      backplate = 'images/backgrounds/MB/M-B_backplate.jpg';
      pattern = 'images/backgrounds/MB/M-B_pattern_animated.webp';
  }
  return {
    backplate,
    pattern,
  };
}
